import React from 'react';

import {
  Button,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { sendAttendContactLate } from '../thunk';

import Confirm from './Confirm';

import type { AttendContactLateJson } from '@/types/domain/attendContact/entities/attendContactLateEntity';
import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';

import DateFieldComp from '@/components/DateFieldComp';
import SelectFieldComp from '@/components/SelectFieldComp';
import TextFieldComp from '@/components/TextFieldComp';
import TimeFieldComp from '@/components/TimeFieldComp';
import { LateDateTime } from '@/domain/attendContact/service/entity/valueObjects/lateDateTime';
import { Memo } from '@/domain/attendContact/service/entity/valueObjects/memo';

/**
 * プロパティ
 */
export type Props = {
  /** 子ども */
  child: ChildJson,
  /** 子どもの施設リスト */
  facilityList: FacilityJson[],
};

type AttendContactJsonInput = {
  nurseryId: string,
  date: string,
  time: string,
  memo: string,
};

const Late: React.FC<Props> = ({ child, facilityList }) => {
  const [
    confirmData,
    setConfirmData,
  ] = React.useState<AttendContactLateJson | undefined>(undefined);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<AttendContactJsonInput>({
    defaultValues: {
      date: LateDateTime.toStringDate(new Date()),
      time: `${LateDateTime.toStringTime(new Date(), false)}:00`,
      memo: '',
      nurseryId: facilityList[0]?.data.facilityId,
    },
  });
  const dispatch = useDispatch();
  const onSubmit = (input: AttendContactJsonInput) => {
    setConfirmData({
      data: {
        nurseryId: input.nurseryId,
        parentId: child.parentId,
        childId: child.childId,
        lateDateTime: `${input.date}T${input.time}`,
        memo: input.memo,
      },
      pub: {
        sendId: `${child.parentId}_${child.childId}`,
        replyId: input.nurseryId,
        data: {},
      },
    });
  };
  const contents = [];
  if (facilityList.length > 0) {
    contents.push(
      <SelectFieldComp
        key="nurseryId"
        control={control}
        name="nurseryId"
        label="送信先"
        rules={{
          required: '必須項目です',
        }}
        errors={errors}
        items={facilityList.map((facility) => ({
          id: facility.data.facilityId,
          name: facility.data.facilityName,
        }))}
        disabled={facilityList.length <= 1}
      />,
    );
  }
  contents.push(
    <DateFieldComp
      key="date"
      control={control}
      name="date"
      label={LateDateTime.labelDate}
      rules={LateDateTime.validationRuleDate}
      errors={errors}
    />,
  );
  const title = '遅刻連絡';
  contents.push(
    <TimeFieldComp
      key="time"
      control={control}
      name="time"
      label={LateDateTime.labelTime}
      rules={LateDateTime.validationRuleTime}
      errors={errors}
    />,
  );
  contents.push(
    <TextFieldComp
      key="memo"
      type="text"
      control={control}
      rules={Memo.validationRule}
      name="memo"
      label={Memo.label}
      placeholder={Memo.placeholder}
      errors={errors}
      multiline
    />,
  );
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <p>{title}</p>
        <div style={{ margin: '10px 0' }}>
          {contents}
        </div>
        <Button
          variant="contained"
          type="submit"
          color="primary"
          fullWidth
        >
          確認
        </Button>
      </form>
      <Confirm
        data={confirmData}
        onSend={(item) => {
          if (item) {
            dispatch(sendAttendContactLate(item));
          }
          setConfirmData(undefined);
        }}
      />
    </div>
  );
};

export default Late;
